import React from 'react';
import { Person } from '../../types';
interface AvatarProps {
  person?: Person;
  size?: number;
  ring?: boolean;
}
function initials(name: string) {
  return name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();
}
export function Avatar({
  person,
  size = 28,
  ring = false
}: AvatarProps) {
  if (!person) {
    return <div className="flex items-center justify-center rounded-full bg-slate-200 text-slate-500" style={{
      width: size,
      height: size,
      fontSize: size * 0.4
    }} aria-hidden data-id="element-17" data-mp="30b1o01xz62nx">
        ?
      </div>;
  }
  return <div className={`flex items-center justify-center rounded-full font-semibold text-white ${ring ? 'ring-2 ring-white' : ''}`} style={{
    width: size,
    height: size,
    backgroundColor: person.color,
    fontSize: size * 0.38
  }} title={person.name} aria-label={person.name} data-id="element-18" data-mp="3e3r8g1xuuzix">
      {initials(person.name)}
    </div>;
}
export function AvatarStack({
  people,
  size = 24
}: {
  people: Person[];
  size?: number;
}) {
  return <div className="flex items-center" data-id="element-19" data-mp="2bbwtyvoh115k">
      {people.map((p, i) => <div key={p.id} style={{
      marginLeft: i === 0 ? 0 : -size * 0.3,
      zIndex: people.length - i
    }} data-id="element-20" data-mp="279tdfsmy36df" data-mpi={i}>
          <Avatar person={p} size={size} ring data-id="element-21" data-mp="2l9ky2c7yvl0e" />
        </div>)}
    </div>;
}